module.exports = __webpack_public_path__ + "static/media/WEB21.35713498.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/WEB21.jpg
// module id = 91
// module chunks = 0